import { render, staticRenderFns } from "./RptAllMchTraTot.vue?vue&type=template&id=2dcb3e4f"
import script from "./RptAllMchTraTot.vue?vue&type=script&lang=js"
export * from "./RptAllMchTraTot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports